<div class="agpr-viAnswerScores">
    <agpr-vi-engine-selector
        [id]="id + '_engineSelector'"
        [engines]="engines"
        [selectedType]="selectedEngine?.type ?? null"
        [showAllEnginesOption]="true"
        (selectedTypeChange)="onEngineSelectionChange($event)"
    >
        <div class="agpr-viAnswerScores-content">
            <h3 class="agpr-viAnswerScores-header">
                @if (selectedEngine) {
                    <img
                        class="agpr-viAnswerScores-headerImage"
                        [src]="appBaseHref + selectedEngine.logoUrl"
                        alt=""
                        aria-hidden="true"
                    />
                    <span class="agpr-viAnswerScores-headerText">{{ selectedEngine.label | localize }}</span>
                } @else {
                    <span class="agpr-viAnswerScores-headerIcon fa-regular fa-rectangle-history" aria-hidden="true"></span>
                    <span class="agpr-viAnswerScores-headerText">{{ 'Vi.qnA.answerScore.overall' | localize }}</span>
                }
            </h3>

            @if (isUnavailable) {
                <agpr-message [severity]="messageSeverity.noContent">
                    <span>{{ 'Vi.qnA.answerScore.noData' | localize }}</span>
                </agpr-message>
            } @else {
                <agpr-scroll-panel>
                    <div class="agpr-viAnswerScores-cardChartList">
                        <agpr-card-chart
                            [id]="id + '_brandScore'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="brandScore.series"
                            [color]="cardChartComponentHighlightColors.blue"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [showCustomValue]="brandScore.customValue !== undefined"
                            [bubbleTooltipLocalizationPrefix]="'Vi.qnA.answerScore.bubbleTooltip'"
                            [bubbleTooltipSubjectLocalizationString]="'Vi.qnA.answerScore'"
                            [bubbleTooltipMetric]="'brandScore'"
                        >
                            <span card-chart-custom-value>{{ brandScore.customValue }}</span>
                        </agpr-card-chart>

                        <agpr-card-chart
                            [id]="id + '_brandMentioned'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="brandMentioned.series"
                            [color]="cardChartComponentHighlightColors.purple"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [hidePrevious]="true"
                            [isPercentage]="true"
                            [showCustomValue]="brandMentioned.customValue !== undefined"
                        >
                            <span card-chart-custom-value>{{ brandMentioned.customValue }}</span>
                        </agpr-card-chart>

                        <agpr-card-chart
                            [id]="id + '_mentionRank'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="mentionRank.series"
                            [color]="cardChartComponentHighlightColors.lightBlue"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [hidePrevious]="true"
                            [showCustomValue]="mentionRank.customValue !== undefined"
                        >
                            <span card-chart-custom-value>{{ mentionRank.customValue }}</span>
                        </agpr-card-chart>

                        <agpr-card-chart
                            [id]="id + '_organicInclusion'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="organicInclusion.series"
                            [color]="cardChartComponentHighlightColors.orange"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [showCustomValue]="organicInclusion.customValue !== undefined"
                            [bubbleTooltipLocalizationPrefix]="'Vi.qnA.answerScore.bubbleTooltip'"
                            [bubbleTooltipSubjectLocalizationString]="'Vi.qnA.answerScore'"
                            [bubbleTooltipMetric]="'organicInclusion'"
                        >
                            <span card-chart-custom-value>{{ organicInclusion.customValue }}</span>
                        </agpr-card-chart>

                        <agpr-card-chart
                            [id]="id + '_sentiment'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="sentiment.series"
                            [color]="cardChartComponentHighlightColors.yellow"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [showCustomValue]="sentiment.customValue !== undefined"
                            [bubbleTooltipLocalizationPrefix]="'Vi.qnA.answerScore.bubbleTooltip'"
                            [bubbleTooltipSubjectLocalizationString]="'Vi.qnA.answerScore'"
                            [bubbleTooltipMetric]="'sentiment'"
                        >
                            <span card-chart-custom-value>{{ sentiment.customValue }}</span>
                        </agpr-card-chart>

                        <agpr-card-chart
                            [id]="id + '_accuracy'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="accuracy.series"
                            [color]="cardChartComponentHighlightColors.lightGreen"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [showCustomValue]="accuracy.customValue !== undefined"
                            [bubbleTooltipLocalizationPrefix]="'Vi.qnA.answerScore.bubbleTooltip'"
                            [bubbleTooltipSubjectLocalizationString]="'Vi.qnA.answerScore'"
                            [bubbleTooltipMetric]="'accuracy'"
                        >
                            <span card-chart-custom-value>{{ accuracy.customValue }}</span>
                        </agpr-card-chart>

                        <agpr-card-chart
                            [id]="id + '_riskFlag'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="riskFlag.series"
                            [color]="cardChartComponentHighlightColors.green"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [hidePrevious]="true"
                            [showCustomValue]="riskFlag.customValue !== undefined"
                        >
                            <span
                                card-chart-custom-value
                                [pTooltip]="riskFlag.tooltip ?? ''"
                            >
                                {{ riskFlag.customValue }}
                            </span>
                        </agpr-card-chart>

                        <!-- TODO: no evidence in ViMetadata yet -->
                        <!-- <agpr-card-chart
                            [id]="id + '_evidence'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="evidenceSeries"
                            [color]="cardChartComponentHighlightColors.teal"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                        ></agpr-card-chart> -->

                        <agpr-card-chart
                            [id]="id + '_citationCount'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="citationCount.series"
                            [color]="cardChartComponentHighlightColors.aqua"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [showCustomValue]="citationCount.customValue !== undefined"
                            [bubbleTooltipLocalizationPrefix]="'Vi.qnA.answerScore.bubbleTooltip'"
                            [bubbleTooltipSubjectLocalizationString]="'Vi.qnA.answerScore'"
                            [bubbleTooltipMetric]="'citationCount'"
                        >
                            <span card-chart-custom-value>{{ citationCount.customValue }}</span>
                        </agpr-card-chart>

                        <agpr-card-chart
                            [id]="id + '_ownDomainCited'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="ownDomainCited.series"
                            [color]="cardChartComponentHighlightColors.coralPink"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [hidePrevious]="true"
                            [isPercentage]="true"
                            [showCustomLabel]="true"
                            [showCustomValue]="ownDomainCited.customValue !== undefined"
                        >
                            <div card-chart-custom-label>
                                <span class="agpr-viAnswerScores-cardChart-ownDomainCited-title">{{ 'Vi.qnA.answerScore.ownDomainCited' | localize }}</span>
                                @if (ownDomainCited.urls?.length) {
                                    <div class="agpr-viAnswerScores-cardChart-ownDomainCited-urlList">
                                        @for(url of ownDomainCited.urls; track url.href) {
                                            <a
                                                [id]="id + '_carChart_citationLink_' + $index"
                                                class="agpr-link"
                                                [href]="url.href"
                                                target="_blank"
                                            >{{ url.label }}</a>
                                        }
                                    </div>
                                }
                            </div>
                            <span
                                card-chart-custom-value
                                class="agpr-viAnswerScores-cardChart-ownDomainCited-value"
                            >
                                {{ ownDomainCited.customValue }}
                            </span>
                        </agpr-card-chart>

                        <agpr-card-chart
                            [id]="id + '_competitorsMentioned'"
                            class="agpr-viAnswerScores-cardChart"
                            [series]="competitorsMentioned.series"
                            [color]="cardChartComponentHighlightColors.lavender"
                            [layout]="cardChartLayout.vertical"
                            [headingLevel]="4"
                            [hidePrevious]="true"
                            [isPercentage]="true"
                            [showCustomValue]="competitorsMentioned.customValue !== undefined"
                        >
                            <span card-chart-custom-value>{{ competitorsMentioned.customValue }}</span>
                        </agpr-card-chart>
                    </div>
                </agpr-scroll-panel>
            }
        </div>
    </agpr-vi-engine-selector>
</div>
